import React, { type FC, Fragment } from 'react'
import { Chip, type ChipProps, Grid } from '@mui/material'

import { StatusDot } from '../common'
import { DefaultIcon } from './DefaultIcon'

const variants = ['neutral', 'primary'] as const satisfies readonly ChipProps['variant'][]

const sizes = ['small', 'medium'] as const satisfies readonly ChipProps['size'][]

const statusVariants = ['success', 'warning', 'danger', 'grey'] as const satisfies readonly ChipProps['variant'][]

export const Chips: FC = () => {
    return (
        <>
            {variants.map((variant) => (
                <Fragment key={variant}>
                    {/* Without icon */}
                    <Grid container spacing={2} sx={{ my: 6 }}>
                        {sizes.map((size) => <Chip key={size} label="Chip" variant={variant} size={size} onDelete={() => {}} sx={{ mr: 4 }} />)}
                    </Grid>

                    {/* With icon */}
                    <Grid container spacing={2} sx={{ my: 6 }}>
                        {sizes.map((size) => (
                            <Chip key={size} label="Chip" variant={variant} size={size} icon={<DefaultIcon />} onDelete={() => {}} sx={{ mr: 4 }} />
                        ))}
                    </Grid>
                </Fragment>
            ))}

            {/* Status variants are not interactive, so they carry no delete icon */}
            <Grid container spacing={2} sx={{ my: 6 }}>
                {statusVariants.map((variant) => <Chip key={variant} label={variant} variant={variant} size="medium" icon={<StatusDot />} sx={{ mr: 4 }} />)}
            </Grid>
            <Grid container spacing={2} sx={{ my: 6 }}>
                {statusVariants.map((variant) => <Chip key={variant} label={variant} variant={variant} size="medium" sx={{ mr: 4 }} />)}
            </Grid>
        </>
    )
}
